import { convertDeedDataToDeedResponse, convertDeedResponseToDeedData, IDeedData, IDeedResponse } from './IDeed';
import {
  convertMortgageDataToMortgageResponse,
  convertMortgageResponseToMortgageData,
  IMortgageData,
  IMortgageResponse,
} from './IMortgage';
import {
  convertSummaryDataToSummaryResponse,
  convertSummaryResponseToSummaryData,
  ISummaryData,
  ISummaryResponse,
} from './ISummary';
import {
  convertLegalAndVestingDataToLegalAndVestingResponse,
  convertLegalAndVestingResponseToLegalAndVestingData,
  ILegalAndVestingData,
  ILegalAndVestingResponse,
} from './ILegalAndVesting';
import {
  convertJudgementInformationDataToJudgementInformationResponse,
  convertJudgementInformationResponseToJudgementInformationData,
  IJudgementInformationData,
  IJudgementInformationResponse,
} from './IJudgement';
import {
  convertBankruptcyDataToBankruptcyResponse,
  convertBankruptcyResponseToBankruptcyData,
  IBankruptcyData,
  IBankruptcyResponse,
} from './IBankruptcy';
import { isNil } from 'lodash';

export interface ITitleReportResponse {
  deedInformation?: IDeedResponse[];
  mortgageInformation?: IMortgageResponse[];
  summary?: ISummaryResponse;
  legalAndVesting?: ILegalAndVestingResponse;
  judgementInformation?: IJudgementInformationResponse;
  bankruptcyInformation?: IBankruptcyResponse;
}
export interface ITitleReportData {
  deedInformation?: IDeedData[];
  mortgageInformation?: IMortgageData[];
  summary?: ISummaryData;
  legalAndVesting?: ILegalAndVestingData;
  judgementInformation?: IJudgementInformationData;
  bankruptcyInformation?: IBankruptcyData;
}

export const createDefaultTitleReportData = (): ITitleReportData => ({});

export const convertTitleReportResponseToTitleReportData = (res: ITitleReportResponse): ITitleReportData => ({
  deedInformation: isNil(res.deedInformation)
    ? res.deedInformation
    : res.deedInformation!.map((d) => convertDeedResponseToDeedData(d)),
  mortgageInformation: isNil(res.mortgageInformation)
    ? res.mortgageInformation
    : res.mortgageInformation!.map((d) => convertMortgageResponseToMortgageData(d)),
  summary: res.summary ? convertSummaryResponseToSummaryData(res.summary) : res.summary,
  legalAndVesting: res.legalAndVesting
    ? convertLegalAndVestingResponseToLegalAndVestingData(res.legalAndVesting)
    : res.legalAndVesting,
  judgementInformation: res.judgementInformation
    ? convertJudgementInformationResponseToJudgementInformationData(res.judgementInformation)
    : res.judgementInformation,
  bankruptcyInformation: res.bankruptcyInformation
    ? convertBankruptcyResponseToBankruptcyData(res.bankruptcyInformation)
    : res.bankruptcyInformation,
});

export const convertTitleReportDataToTitleReportResponse = (data: ITitleReportData): ITitleReportResponse => ({
  deedInformation: isNil(data.deedInformation)
    ? data.deedInformation
    : data.deedInformation!.map((d) => convertDeedDataToDeedResponse(d)),
  mortgageInformation: isNil(data.mortgageInformation)
    ? data.mortgageInformation
    : data.mortgageInformation!.map((d) => convertMortgageDataToMortgageResponse(d)),
  summary: data.summary ? convertSummaryDataToSummaryResponse(data.summary) : data.summary,
  legalAndVesting: data.legalAndVesting
    ? convertLegalAndVestingDataToLegalAndVestingResponse(data.legalAndVesting)
    : data.legalAndVesting,
  judgementInformation: data.judgementInformation
    ? convertJudgementInformationDataToJudgementInformationResponse(data.judgementInformation)
    : data.judgementInformation,
  bankruptcyInformation: data.bankruptcyInformation
    ? convertBankruptcyDataToBankruptcyResponse(data.bankruptcyInformation)
    : data.bankruptcyInformation,
});
